import React from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";

import { BackgroundWrapper, Breadcrumb, ObjValidator } from "components";
import { useTranslate } from "hooks";
import type { ObjValidatorProps } from "interfaces/shared.types";

const ContentPage = Scrivito.connect(({ page }: ObjValidatorProps) => {
  const translate = useTranslate();

  if (!page) {
    return null;
  }

  const isBreadcrumbsHidden = page.get("breadCrumbs") === "No";
  const isLargePaddingsY = page.get("largePaddingsY") === "Yes";
  const isDarkBg = page.get("darkBg") === "Yes";

  return (
    <React.Fragment>
      {!isBreadcrumbsHidden && <Breadcrumb page={Scrivito.currentPage()} />}
      <BackgroundWrapper
        page={page}
        classNames={cx({
          "py-8": isLargePaddingsY,
        })}
      >
        <>
          <div className="mb-6 ">
            <h1 className={cx({ "text-white": isDarkBg })}>
              {translate("WELCOME_PAGE_TITLE")}
            </h1>
            <div className="row">
              <div
                className={cx(
                  { "text-gray-400": isDarkBg },
                  "font-md col-md-9 d-flex flex-column gap-3",
                )}
                data-testid="body"
              >
                <div data-testid="welcome-body-text-part1">
                  {translate("WELCOME_PAGE_BODY_TEXT_PART1")}
                </div>
                <div data-testid="welcome-body-text-part2">
                  {translate("WELCOME_PAGE_BODY_TEXT_PART2")}
                </div>
              </div>
            </div>
          </div>

          <Scrivito.ContentTag
            className="content-widgets"
            content={page}
            attribute="contentWidgets"
            tag="div"
          />
        </>
      </BackgroundWrapper>
    </React.Fragment>
  );
});

const CheckedPage = (props: ObjValidatorProps) => (
  <ObjValidator {...props}>
    <ContentPage {...props} />
  </ObjValidator>
);
export default CheckedPage;
Scrivito.provideComponent("ContentPage", CheckedPage);
